import { render, staticRenderFns } from "./acoes.vue?vue&type=template&id=8e46027e"
import script from "./acoes.vue?vue&type=script&lang=js"
export * from "./acoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports